export default "__VITE_ASSET__CaYSX7KN__"